import CostCalculator from "./CostCalculator";
import RoiCalculator from "./RoiCalculator";
import ContextWindowDemo from "./ContextWindowDemo";
import TokenCounter from "./TokenCounter";
import PollingVsWebhook from "./PollingVsWebhook";
import PlatformCostCurve from "./PlatformCostCurve";
import SpotTheHallucination from "./SpotTheHallucination";
import SubscriptionCrossover from "./SubscriptionCrossover";
import ChurnCompounding from "./ChurnCompounding";
import PaybackVsLifetime from "./PaybackVsLifetime";
import FreemiumEconomics from "./FreemiumEconomics";
import BreakEvenChart from "./BreakEvenChart";
import AbTestSignificance from "./AbTestSignificance";
import ProcessorFees from "./ProcessorFees";
import SlicingPlayground from "./SlicingPlayground";
import AliasVsCopy from "./AliasVsCopy";
import GeneratorMemory from "./GeneratorMemory";
import AsyncTimeline from "./AsyncTimeline";
import RegexTester from "./RegexTester";
import EventLoopOrder from "./EventLoopOrder";
import ClosureCounters from "./ClosureCounters";
import HoistingTdz from "./HoistingTdz";
import EventPhases from "./EventPhases";
import ReferenceVsValue from "./ReferenceVsValue";
import MeFlatRateTax from "./MeFlatRateTax";
import MeVatThresholds from "./MeVatThresholds";
import MeContributions from "./MeContributions";
import MeTurnoverToIncome from "./MeTurnoverToIncome";
import MeAcreSwitch from "./MeAcreSwitch";

/**
 * Démos jouables insérables dans le contenu d'un terme de glossaire.
 *
 * Le contenu stocké en base pose un marqueur :
 *   <div data-glossary-demo="cost" data-lang="fr"></div>
 * et transformHtml le remplace par le composant correspondant.
 *
 * Une clé inconnue ne rend rien : un contenu importé avec un marqueur obsolète
 * ne casse pas la page.
 */
export const GLOSSARY_DEMOS = {
    cost: CostCalculator,
    roi: RoiCalculator,
    context: ContextWindowDemo,
    tokens: TokenCounter,
    polling: PollingVsWebhook,
    platforms: PlatformCostCurve,
    hallucination: SpotTheHallucination,

    // Glossaire du business en ligne
    recurring: SubscriptionCrossover,
    churn: ChurnCompounding,
    payback: PaybackVsLifetime,
    freemium: FreemiumEconomics,
    breakeven: BreakEvenChart,
    abtest: AbTestSignificance,
    fees: ProcessorFees,

    // Glossaire Python
    slicing: SlicingPlayground,
    alias: AliasVsCopy,
    genmemory: GeneratorMemory,
    asynctime: AsyncTimeline,
    regex: RegexTester,

    // Glossaire JavaScript
    jseventloop: EventLoopOrder,
    jsclosure: ClosureCounters,
    jshoisting: HoistingTdz,
    jspropagation: EventPhases,
    jsrefval: ReferenceVsValue,

    // Glossaire de la micro-entreprise. Les taux et seuils qu'elles portent
    // viennent du référentiel arbitré (docs/glossaries/micro-entreprise/
    // reference-2026.json) et se relisent avec lui, pas séparément.
    mevfl: MeFlatRateTax,
    meseuils: MeVatThresholds,
    mecotisations: MeContributions,
    mecavsrevenu: MeTurnoverToIncome,
    meacre: MeAcreSwitch,
};
